<template>
    <div>
    <h1>VACANSES</h1>

    </div>
</template>

<script>

    export default {
        name: "Vacances",

    }
</script>

<style scoped>

</style>
